"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCheckboxList = createCheckboxList;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createCheckboxList(baseDataTestId, selectedFilters, handleFilterChange, items, liftInfoMessage) {
  var isDlp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  function isSRHotelFilter(item) {
    return 'code' in item;
  }
  var LIFT_ACCESS_CODE = isDlp ? 'LFT,HUL' : 'LFT';
  return items.map(item => {
    var itemCode = isSRHotelFilter(item) ? item.code : item.codes;
    var itemName = isSRHotelFilter(item) ? item.name : item.label;
    var selectedDlpFiltersCodes = selectedFilters.map(filter => filter.codes);
    return (0, _jsxRuntime.jsx)(_atoms.Checkbox, {
      my: "xs",
      value: itemCode,
      "aria-label": itemName,
      isChecked: isDlp ? selectedDlpFiltersCodes.some(filterCodes => {
        if (filterCodes.length > 1) {
          return filterCodes.some(filter => {
            return itemCode === null || itemCode === void 0 ? void 0 : itemCode.includes(filter);
          });
        }
        return filterCodes[0] === itemCode;
      }) : selectedFilters.some(filterCode => filterCode === itemCode),
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, "Filters-checkbox-".concat(itemCode)),
      onChange: handleFilterChange,
      children: itemCode === LIFT_ACCESS_CODE ? (0, _jsxRuntime.jsxs)(_react.Flex, {
        direction: "row",
        display: "inline-flex",
        children: [(0, _jsxRuntime.jsx)(_react.Text, {
          children: itemName
        }), (0, _jsxRuntime.jsx)(_atoms.Tooltip, _objectSpread(_objectSpread({
          description: liftInfoMessage,
          variant: "facilities",
          placement: "bottom-start",
          position: "relative",
          alertElementStyles: alertStyles,
          "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Filters-Lift-access-info-tooltip')
        }, tooltipStyles), {}, {
          children: (0, _jsxRuntime.jsx)(_react.Text, {
            as: "div",
            "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Filters-Lift-access-info-icon'),
            children: (0, _jsxRuntime.jsx)(_atoms.Icon, {
              ml: "sm",
              mt: "xs",
              svg: (0, _jsxRuntime.jsx)(_atoms.Info, {})
            })
          })
        }))]
      }) : (0, _jsxRuntime.jsx)(_react.Text, {
        children: itemName
      })
    }, itemCode);
  });
}
var alertStyles = {
  py: 'sm',
  padding: 0,
  w: '11.625rem',
  h: '6.125rem'
};
var tooltipStyles = {
  marginLeft: '-1rem',
  fontSize: 'sm',
  lineHeight: '2',
  paddingLeft: 0,
  fontWeight: 'normal',
  top: 'xs'
};